let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("edPhJ"), load("809Jq"), load("6hCrU"), load("78EJ0")]).then(() => parcelRequire('c0sxZ'));